import { BuildingServiceType, ServiceTypeEnum } from "../types/Building";

// Centralizes the "custom display name with fallback" lookup shared across nav, list, and detail views.
export function useServiceDisplayName(
  serviceTypes: BuildingServiceType[] | undefined,
  serviceType: ServiceTypeEnum,
  fallback: string
): string {
  const service = serviceTypes?.find(
    (s: BuildingServiceType) => s.serviceType === serviceType
  );

  return service?.displayName || fallback;
}
